<template>
  <star-rating
    :rating="rating"
    :read-only="true"
    :star-size="22"
    text-class="hidden"
    active-color="#fdcf6e"
    :border-width="2"
    border-color="transparent"
    :rounded-corners="true"
    :active-color="activeColor"
    :inactive-color="inactiveColor"
    :star-points="[
      23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31,
      17,
    ]"
  />
</template>

<script>
export default {
  name: "Rate",
  props: {
    rating: { type: Number, required: true },
    activeColor: { type: String, required: false },
    inactiveColor: { type: String, required: false },
  },
};
</script>
